import clsx from "clsx";

export const container = clsx(
    "relative flex flex-col items-center justify-center mt-6",
);

export const imgWrapper = clsx(
    "relative md:h-[300px] md:w-[360px] mt-2 md:mt-0 flex flex-col items-center",
);

export const navigation = clsx(
    "-mt-16 max-w-[90%] flex transform items-center justify-between rounded-full bg-darkGray px-4 py-2",
);

export const caption = clsx(
    "mt-10 md:-mt-2 max-w-[350px] text-xs text-center md:text-left",
);
